import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const postReview = async (data, token) => {
  try {
    const res = await axios({
      method: "post",
      url: baseurl + `/review`,
      headers: {
        token: token,
      },
      data: data,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getReview = async (id, token) => {
  try {
    const res = await axios({
      method: "post",
      url: baseurl + `/getReview`,
      headers: {
        token: token,
      },
      data: { productId: id },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
